import React from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon } from 'lucide-react';
interface TestimonialCardProps {
  name: string;
  age: number;
  city: string;
  quote: string;
  delay?: number;
}
export function TestimonialCard({
  name,
  age,
  city,
  quote,
  delay = 0
}: TestimonialCardProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.5,
    delay
  }} className="bg-neutral-800 border border-neutral-700 p-6 rounded-xl shadow-lg hover:border-amber-500/50 transition-colors duration-300" data-id="element-38">
      <div className="flex items-start mb-4" data-id="element-39">
        <div className="bg-amber-500/10 p-2 rounded-full mr-3" data-id="element-40">
          <QuoteIcon className="w-5 h-5 text-amber-500" data-id="element-41" />
        </div>
        <div data-id="element-42">
          <h3 className="font-bold text-white text-lg" data-id="element-43">{name}</h3>
          <p className="text-neutral-400 text-sm" data-id="element-44">
            {age} años, {city}
          </p>
        </div>
      </div>
      <p className="text-neutral-300 italic leading-relaxed" data-id="element-45">"{quote}"</p>
    </motion.div>;
}